<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div
      class="modal fade"
      id="modal_form_tifreglas_export"
      style="background-color: #00000082"
    >
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">
              Generar listado Tif Reglas Operativas
            </h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal1"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="tab-Columnas"
                  data-toggle="tab"
                  href="#Columnas"
                  >Columnas</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="tab-Filtros"
                  data-toggle="tab"
                  href="#Filtros"
                  >Filtros
                </a>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane" id="Filtros">
                <div class="card-body">
                  <div class="form-group row">
                    <label for="bloque_id" class="col-md-5">Bloque</label>
                    <v-select
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="bloque"
                      placeholder="Bloque"
                      label="nombre"
                      class="form-control form-control-sm p-0 col-md-7"
                      :options="listasForms.bloques"
                      :filterable="true"
                      @input="getSelectBloque()"
                    ></v-select>
                  </div>
                  <div class="form-group row">
                    <label for="tipo_novedad" class="col-md-5">
                      Tipo Novedad</label
                    >
                    <select
                      id="tipo_novedad"
                      class="form-control form-control-sm col-md-7"
                      v-model="filtros.tipo_novedad"
                    >
                      <option value="">Seleccione...</option>
                      <option
                        v-for="tipo_novedad in listasForms.tipos_novedades"
                        :key="tipo_novedad.numeracion"
                        :value="tipo_novedad.numeracion"
                      >
                        {{ tipo_novedad.descripcion }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group row">
                    <label for="causa_novedad" class="col-md-5">
                      Causa Novedad</label
                    >
                    <select
                      id="causa_novedad"
                      class="form-control form-control-sm col-md-7"
                      v-model="filtros.causa_novedad"
                    >
                      <option value="">Seleccione...</option>
                      <option
                        v-for="causa_novedad in listasForms.causas_novedades"
                        :key="causa_novedad.numeracion"
                        :value="causa_novedad.numeracion"
                      >
                        {{ causa_novedad.descripcion }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group row">
                    <label for="estado1" class="col-md-5"> Estado</label>
                    <select
                      id="estado"
                      class="form-control form-control-sm col-md-7"
                      v-model="filtros.estado"
                    >
                      <option value="">Seleccione...</option>
                      <option
                        v-for="estado in listasForms.estados"
                        :key="estado.numeracion"
                        :value="estado.numeracion"
                      >
                        {{ estado.descripcion }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade active show" id="Columnas">
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-11">
                      <div class="form-group">
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="bloque_id"
                              v-model="form.bloque_id"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="bloque_id"
                              >Bloque</label
                            >
                          </div>
                        </div>

                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="tipo_novedad1"
                              v-model="form.tipo_novedad"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="tipo_novedad1"
                              >Tipo Novedad</label
                            >
                          </div>
                        </div>

                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="tiempo"
                              v-model="form.tiempo"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="tiempo"
                              >Tiempo</label
                            >
                          </div>
                        </div>

                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="causa_novedad1"
                              v-model="form.causa_novedad"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="causa_novedad1"
                              >Causa Novedad</label
                            >
                          </div>
                        </div>

                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="estado1"
                              v-model="form.estado"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="estado1"
                              >Estado</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer justify-content-between">
            <div>
              <button
                type="button"
                class="btn btn-sm bg-navy"
                @click="generarListadoExcel()"
                v-if="$store.getters.can('tif.reglasOperativas.export')"
              >
                Generar Listado
                <i class="fas fa-file-download"> </i>
              </button>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import Loading from "../../../../components/Loading";
export default {
  name: "ReglasOperativasExport",
  components: {
    Loading,
    vSelect,
  },
  data() {
    return {
      cargando: false,
      bloque: {},
      form: {
        bloque_id: true,
        tipo_novedad: true,
        tiempo: true,
        causa_novedad: true,
        estado: true,
      },
      filtros: {
        tipo_novedad: null,
        causa_novedad: null,
        tiempo: null,
        estado: null,
      },
      listasForms: {
        causas_novedades: [],
        tipos_novedades: [],
        bloques: [],
        estados: [],
      },
    };
  },

  methods: {
    async getBloque() {
      await axios.get("/api/admin/bloques/lista").then((response) => {
        this.listasForms.bloques = response.data;
      });
    },

    getSelectBloque() {
      this.filtros.bloque = {};
      this.filtros.bloque_id = null;
      if (this.bloque) {
        this.filtros.bloque = this.bloque;
        this.filtros.bloque_id = this.bloque.id;
      }
    },

    getTipoNovedad() {
      axios.get("/api/lista/105").then((response) => {
        this.listasForms.tipos_novedades = response.data;
      });
    },

    getCausaNovedad() {
      axios.get("/api/lista/104").then((response) => {
        this.listasForms.causas_novedades = response.data;
      });
    },

    getEstados() {
      axios.get("/api/lista/1").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    generarListadoExcel() {
      this.cargando = true;
      axios({
        method: "POST",
        url: "/api/tif/reglasOperativas/export",
        data: { form: this.form, filtros: this.filtros },
      })
        .then((response) => {
          let data = response.data;
          this.cargando = false;
          location.href = data.url;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },
  },

  async mounted() {
    this.cargando = true;
    await this.getBloque();
    await this.getCausaNovedad();
    await this.getTipoNovedad();
    await this.getEstados();
    this.cargando = false;
  },
};
</script>
